import { RuleValidator } from '../types';

export const dateRules: Record<string, RuleValidator> = {
    date: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (value instanceof Date) return !isNaN(value.getTime());
        if (typeof value === 'string') {
            const date = new Date(value);
            return !isNaN(date.getTime());
        }
        return false;
    },

    before: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const dateValue = value instanceof Date ? value : new Date(value);
        const compareDate = params[0] instanceof Date ? params[0] : new Date(params[0]);

        if (isNaN(dateValue.getTime()) || isNaN(compareDate.getTime())) return false;

        return dateValue < compareDate;
    },

    after: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const dateValue = value instanceof Date ? value : new Date(value);
        const compareDate = params[0] instanceof Date ? params[0] : new Date(params[0]);

        if (isNaN(dateValue.getTime()) || isNaN(compareDate.getTime())) return false;

        return dateValue > compareDate;
    },

    betweenDates: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const dateValue = value instanceof Date ? value : new Date(value);
        const startDate = params[0] instanceof Date ? params[0] : new Date(params[0]);
        const endDate = params[1] instanceof Date ? params[1] : new Date(params[1]);

        if (isNaN(dateValue.getTime()) || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return false;

        return dateValue >= startDate && dateValue <= endDate;
    }
};